/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Facet_Meal_PrepInputs */

const en_facet_meal_prep = /** @type {(inputs: Facet_Meal_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal-prep friendly`)
};

const de_facet_meal_prep = /** @type {(inputs: Facet_Meal_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal-Prep-geeignet`)
};

/**
* | output |
* | --- |
* | "Meal-prep friendly" |
*
* @param {Facet_Meal_PrepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const facet_meal_prep = /** @type {((inputs?: Facet_Meal_PrepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Facet_Meal_PrepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_facet_meal_prep(inputs)
	return en_facet_meal_prep(inputs)
});